import InfiniteScroll from 'react-infinite-scroll-component';
import { Role } from 'auth';
import { Fragment, useCallback, useContext, useId } from 'react';
import '@/modules/common/styles/common.css';
import { AdminRegisterItem } from '@/modules/admin-dashboard/components/items/AdminRegisterItem.tsx';
import { AdminRegisterModal } from '@/modules/admin-dashboard/components/modals/AdminRegisterModal.tsx';
import { useAdminRegisterListQuery } from '@/modules/admin-dashboard/queries/registers.tsx';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { Button, EmptyListState, ModalProviderContext, PageLayout, Spinner } from 'ui';

const AdminRegisters = () => {
  const { openModal } = useContext(ModalProviderContext);
  const {
    data: registersData,
    fetchNextPage: fetchNextRegisterListPage,
    hasNextPage: registerListHasNextPage,
    isLoading: isRegisterListLoading,
  } = useAdminRegisterListQuery({ page: 1, page_size: 15 }, { cacheKey: useId() });

  const handleOpenAddRegisterModal = useCallback(() => {
    openModal(AdminRegisterModal);
  }, [openModal]);
  return (
    <PageLayout
      title="Registers"
      headerAction={
        <Button className="w-[180px]" onClick={handleOpenAddRegisterModal}>
          Create new register
        </Button>
      }
    >
      <EmptyListState
        title="No registries created yet"
        description="Create your first registry"
        isLoading={isRegisterListLoading}
        isSearchUsed={false}
        itemsCount={registersData?.pages?.[0]?.total || 0}
      />
      {isRegisterListLoading && (
        <div className="w-full h-full flex items-center justify-center">
          <Spinner size="lg" />
        </div>
      )}
      {registersData && registersData?.pages?.[0]?.total > 0 && (
        <InfiniteScroll
          next={fetchNextRegisterListPage}
          dataLength={registersData?.pages?.length ?? 0}
          hasMore={registerListHasNextPage || false}
          style={{ overflow: 'unset' }}
          loader={
            <div className="flex justify-center items-center h-16 w-full">
              <Spinner size="md" variant="primary" />
            </div>
          }
          scrollableTarget="scrollable"
        >
          <div className="w-full flex flex-col gap-2">
            {registersData?.pages?.map((registers, i) => (
              <Fragment key={i}>
                {registers?.data?.map((register, j) => (
                  <AdminRegisterItem
                    key={'register_' + register.id}
                    register={register}
                    index={i + 1 + j}
                  />
                ))}
              </Fragment>
            ))}
          </div>
        </InfiniteScroll>
      )}
    </PageLayout>
  );
};

export default withPrivateAccess(AdminRegisters, Role.SR_ADMIN);
